module.exports = __webpack_public_path__ + "assets/img/FXH.e8c5a6ec.png";